import { __rest } from "tslib";
import React from 'react';
import { Linking } from 'react-native';
var PnmacNavigation = function (_a) {
  var _b, _c, _d, _e, _f, _g, _h;
  var action = _a.action,
    target = _a.target,
    wind = _a.wind,
    props = __rest(_a, ["action", "target", "wind"]);
  if (wind) {
    if ((_b = props === null || props === void 0 ? void 0 : props.layout) === null || _b === void 0 ? void 0 : _b.mobile) {
      Linking.openURL(action);
    } else {
      window.open(action, target);
    }
  } else {
    if ((_c = props === null || props === void 0 ? void 0 : props.layout) === null || _c === void 0 ? void 0 : _c.mobile) {
      if (((_d = action.pathname) === null || _d === void 0 ? void 0 : _d.indexOf("Amortization Calculator")) > -1) {
        Linking.openURL("".concat((_e = props.layout) === null || _e === void 0 ? void 0 : _e.pennyHomeUrl).concat((_f = action.pathname) === null || _f === void 0 ? void 0 : _f.replace(/^\//, ""), "?ids_token=").concat((_g = props.layout) === null || _g === void 0 ? void 0 : _g.token));
      } else {
        if (action.pathname == '/') {
          action.pathname = "BottomNavBar";
        }
        props.navigation.navigate((_h = action.pathname) === null || _h === void 0 ? void 0 : _h.replace(/^\//, ''), action.state);
      }
    } else {
      props.history.push(action);
    }
  }
};
export default PnmacNavigation;